module.exports = __webpack_public_path__ + "static/21-00890650bbdcd8c535144a53558ab42c.png";